// PRODUCTION — Formik-bound checkbox
import React from 'react'
import { useFormikContext } from 'formik'
import {
  flowEditorCheckboxBoxCss,
  flowEditorCheckboxMarkCss,
} from 'src/pages/admin/flow-editor/flowEditorCheckboxStyles'

export interface ProtoCheckboxProps<T> {
  name: keyof T & string
  disabled?: boolean
}

export const ProtoCheckbox = <T extends object>({
  name,
  disabled = false,
}: ProtoCheckboxProps<T>) => {
  const { values, setFieldValue } = useFormikContext<T>()
  const checked = values[name] as unknown as boolean

  return (
    <div
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      onClick={() => {
        if (!disabled) {
          setFieldValue(name, !checked)
        }
      }}
      css={flowEditorCheckboxBoxCss(checked, disabled)}
    >
      {checked && (
        <svg
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          css={flowEditorCheckboxMarkCss(disabled)}
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      )}
    </div>
  )
}
